module.exports = __webpack_public_path__ + "img/test3.adb09e7b.jpg";